import { render, staticRenderFns } from "./AppStoreSelector.vue?vue&type=template&id=1cc5f0c6"
import script from "./AppStoreSelector.vue?vue&type=script&lang=js"
export * from "./AppStoreSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports